module.exports = __webpack_public_path__ + "7bc40c0c778047022b1694a4e762d615.png";